import { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import HeroCarousel from './components/HeroCarousel';
import Overview from './components/Overview';
import Highlights from './components/Highlights';
import Amenities from './components/Amenities';
import WhyChooseUs from './components/WhyChooseUs';
import Pricing from './components/Pricing';
import LocationAdvantages from './components/LocationAdvantages';
import Gallery from './components/Gallery';
import Testimonials from './components/Testimonials';
import AboutDeveloper from './components/AboutDeveloper';
import Contact from './components/Contact';
import Footer from './components/Footer';
import BackToTop from './components/BackToTop';
import ContactModal from './components/ContactModal';

function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const handleOpenModal = () => setIsModalOpen(true);
    window.addEventListener('openContactModal', handleOpenModal);
    return () => window.removeEventListener('openContactModal', handleOpenModal);
  }, []);

  return (
    <div className="App">
      <Navbar />
      <HeroCarousel />
      <Overview />
      <Highlights />
      <Amenities />
      <WhyChooseUs />
      <Pricing />
      <LocationAdvantages />
      <Gallery />
      <Testimonials />
      <AboutDeveloper />
      <Contact />
      <Footer />
      <BackToTop />
      <ContactModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  );
}

export default App;
